import { PatientForm } from './PatientForm';

/**
 * Patient Edit page.
 *
 * Renders the exact same form layout as Patient Registration (/patients/new)
 * by reusing PatientForm in "edit" mode, which loads the existing patient and
 * saves changes via the update mutation.
 */
export function PatientEdit() {
  return <PatientForm mode="edit" />;
}
